import { trackEvent } from '@farmnet/tag-manager';

angular.module('cfn').controller('farmController', farmController);

farmController.$inject = [
  '$scope',
  'bookingImportWizardService',
  'bookingIsoXmlConfig',
];
function farmController(
  $scope,
  bookingImportWizardService,
  bookingIsoXmlConfig,
) {
  $scope.hasModule = app.hasModule;
  $scope.hasRight = app.hasRight;
  $scope.currencyUnit = app.credentials.company.currencyUnit;
  $scope.hasFunctionalAnalysisRight = app.hasRight('Company:FUNCTIONAL_ANALYSIS');
  $scope.hasCompanyPlanningRight = app.hasRight('Company:PLANNING');
  $scope.hasPreliminaryBookingRight = app.hasRight('Company:PRELIMINARY_BOOKING');

  $scope.state = {};

  $scope.isoXmlWizardRights = bookingIsoXmlConfig.requiredRights;

  $scope.showBookingImportWizard = () => {
    bookingImportWizardService.openImportDialog(false);
  };

  $scope.trackFarmNavigation = (title) => {
    const navigationLabel = `Farm::${title}`;

    trackEvent('Navigation', 'Body', navigationLabel);
  };

  return ($scope.farmController = this);
}
